
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { ThemeToggle } from "@/components/ThemeToggle";

const NAV_ITEMS = [
  { id: 'features', label: 'Features' },
  { id: 'pricing', label: 'Pricing' },
  { id: 'faq', label: 'FAQ' }
] as const;

export const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId: string) => {
    // If we're not on the home page, first navigate there
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: sectionId } });
    } else {
      const element = document.getElementById(sectionId);
      element?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Handle scrolling after navigation
  useEffect(() => {
    if (location.pathname === '/' && location.state?.scrollTo) {
      const sectionId = location.state.scrollTo;
      // Small delay to ensure the elements are mounted
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        element?.scrollIntoView({ behavior: 'smooth' });
        // Clean up the state
        navigate('/', { replace: true, state: {} });
      }, 100);
    }
  }, [location.pathname, location.state]);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-stone-200 dark:border-stone-700 bg-white dark:bg-stone-800">
      <div className="container flex h-16 max-w-6xl items-center justify-between mx-auto px-4">
        <Link to="/" className="text-2xl font-semibold dark:text-white">
          <span className="text-orange-500">ielts</span>with.ai
        </Link>

        <nav className="hidden gap-8 md:flex">
          {NAV_ITEMS.map(({ id, label }) => (
            <button
              key={id}
              onClick={() => scrollToSection(id)}
              className="text-sm font-medium text-stone-900 dark:text-white transition-colors hover:text-orange-500 dark:hover:text-orange-500"
            >
              {label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <ThemeToggle />
          <Button
            onClick={() => navigate("/auth")}
            className="rounded-lg bg-orange-500 px-4 py-3 text-sm font-semibold text-white shadow-[inset_0px_1px_0px_0px_#FFFFFF66,0px_0px_0px_1px_#C2410CCC] transition-colors hover:bg-orange-500/90"
          >
            Start Practicing Now
          </Button>
        </div>
      </div>
    </header>
  );
};
